import FormListView from "../presentation/views/FormListView.vue";
// Detail/wizard shell + sections — lazy-loaded so the list bundle stays small.
const FormDetailView = () => import("../presentation/views/FormDetailView.vue");
const CampaignSection = () => import("../presentation/components/sections/CampaignSection.vue");
const BrandingSection = () => import("../presentation/components/sections/BrandingSection.vue");
const AmountsSection = () => import("../presentation/components/sections/AmountsSection.vue");
const MessagesSection = () => import("../presentation/components/sections/MessagesSection.vue");
const SettingsSection = () => import("../presentation/components/sections/SettingsSection.vue");
const FormStatisticsView = () => import("../presentation/views/FormStatisticsView.vue");
export const collecteRoutes = [
    {
        path: "/collecte/forms",
        name: "CollecteFormList",
        component: FormListView,
        meta: { requiresAuth: true, titleKey: "collecte.title" },
    },
    {
        // Parent wizard layout. The empty path redirects to the first section so
        // `/collecte/forms/:id` lands on the campaign tab.
        path: "/collecte/forms/:id",
        name: "CollecteFormDetail",
        component: FormDetailView,
        redirect: { name: "CollecteFormCampaign" },
        meta: { requiresAuth: true, titleKey: "collecte.detail.title" },
        children: [
            {
                path: "campaign",
                name: "CollecteFormCampaign",
                component: CampaignSection,
                meta: { requiresAuth: true, titleKey: "collecte.detail.sections.campaign" },
            },
            {
                path: "branding",
                name: "CollecteFormBranding",
                component: BrandingSection,
                meta: { requiresAuth: true, titleKey: "collecte.detail.sections.branding" },
            },
            {
                path: "amounts",
                name: "CollecteFormAmounts",
                component: AmountsSection,
                meta: { requiresAuth: true, titleKey: "collecte.detail.sections.amounts" },
            },
            {
                path: "messages",
                name: "CollecteFormMessages",
                component: MessagesSection,
                meta: { requiresAuth: true, titleKey: "collecte.detail.sections.messages" },
            },
            {
                path: "settings",
                name: "CollecteFormSettings",
                component: SettingsSection,
                meta: { requiresAuth: true, titleKey: "collecte.detail.sections.settings" },
            },
        ],
    },
    {
        // Read-only statistics report. A STANDALONE top-level record, deliberately NOT a child of
        // CollecteFormDetail: a child would render inside the wizard shell, fall through its
        // `activeSection ?? "campaign"` fallback (lighting up the Campagne tab), and inherit both the
        // unsaved-changes guard and the docked LivePreviewPanel — none of which a report wants.
        //
        // No shadowing by the wizard record above: `/collecte/forms/:id` is a THREE-segment path with
        // named children and no catch-all, so it cannot match this four-segment path. vue-router ranks
        // by segment score (a static `statistics` outranks any param), not by array position, so the
        // placement after the wizard is for readability only.
        path: "/collecte/forms/:id/statistics",
        name: "CollecteFormStatistics",
        component: FormStatisticsView,
        meta: { requiresAuth: true, titleKey: "collecte.statistics.title" },
    },
];
export const collecteNavigationItems = [
    {
        labelKey: "collecte.title",
        children: [
            {
                labelKey: "collecte.forms.title",
                path: "/collecte/forms",
                icon: "ri-hand-heart-line",
                meta: { requiresAuth: true },
            },
        ],
    },
];
